module.exports = __webpack_public_path__ + "static/img/5areaA_12.16906d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/5areaA_12.png
// module id = 1042
// module chunks = 1